import { render, staticRenderFns } from "./CallContactTask.vue?vue&type=template&id=8d9bb6ea&scoped=true"
import script from "./CallContactTask.vue?vue&type=script&lang=ts"
export * from "./CallContactTask.vue?vue&type=script&lang=ts"
import style0 from "./CallContactTask.vue?vue&type=style&index=0&id=8d9bb6ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9bb6ea",
  null
  
)

export default component.exports